// Component and Element names for Analytics `interact` props
import { InteractViewTypes, SubscribeAndAuthViews } from '../types/analytics';
import { LaunchType } from '../types/launch';

export const TRACKING_VIEW_TYPES: InteractViewTypes[] = [
  ...Object.values(LaunchType),
  ...Object.values(SubscribeAndAuthViews),
];

// -----------Components-------------
export const COMPONENT_HEADER = 'header';
export const COMPONENT_FOOTER = 'footer';
export const COMPONENT_HERO = 'hero';

export const COMPONENT_TMOBILE_SELECTION_FORM = 'tmobileSelectionForm';
export const COMPONENT_SUBSCRIPTION_CODE_FORM = 'subscriptionCodeForm';
export const COMPONENT_FAQS = 'faqs';
export const EXPERIMENT_COMPONENT_FAQS = 'experimentFAQs';
export const COMPONENT_ADD_ONS_GROUP = 'addOnsGroup';
export const COMPONENT_USER_IDENT_FORM = 'userIdentForm';
export const COMPONENT_ACTIVATE_DEVICE_FORM = 'activateDeviceForm';

export const COMPONENT_PACKAGE_SELECTION = 'packageSelection';

export const COMPONENT_SITELINKS_NAV = 'sitelinksNav';
export const COMPONENT_SITELINKS_HEADER = 'sitelinksHeader';

export const COMPONENT_DEVICES_LIST = 'devicesList';
export const COMPONENT_PAYMENT_GROUP = 'paymentGroup';
export const COMPONENT_CREDIT_CARD_FORM = 'creditCardForm';

export const COMPONENT_GEO_FENCE = 'geoFence';
export const COMPONENT_LOADER_OVERLAY = 'loaderOverlay';
export const COMPONENT_FLASH_BANNER = 'flashBanner';

export const COMPONENT_AUTHENTICATE_FORM = 'authenticateForm';
export const COMPONENT_AUTHORIZE_FORM = 'authorizeForm';

export const COMPONENT_COMFORT_CHANNEL_HERO = 'comfortChannelHero';

export const COMPONENT_SHOW_PAGE_HERO = 'showPageHero';
export const COMPONENT_SHOW_PAGE_TABS = 'showPageTabs';
export const COMPONENT_SHOW_PAGE_ASSETS = 'showPageAssets';

export const COMPONENT_FAST_CAROUSEL = 'fastPlansModule';
export const COMPONENT_HERO_CAROUSEL = 'heroCarousel';
export const COMPONENT_BENEFITS = 'benefitsModule';
export const COMPONENT_CHANNELS_SEARCH = 'channelFilters';
export const COMPONENT_CHANNEL_TILE = 'channelTile';

export const COMPONENT_SEASON_PICKER = 'seasonPicker';
export const COMPONENT_EPISODES_LIST = 'episodesList';
export const COMPONENT_EPISODE_CARD = 'episodeCard';

// -----------Elements-------------
export const ELEMENT_CLOSE_MODAL = 'closeModal';

export const ELEMENT_PHILO_LOGO = 'philoLogo';
export const ELEMENT_SIGN_IN_BUTTON = 'signInButton';
export const ELEMENT_SUBSCRIBE_BUTTON = 'subscribeButton';
export const ELEMENT_SUBSCRIBE_NOW_BUTTON = 'subscribeNowButton';
export const ELEMENT_SIGN_UP_BUTTON = 'signUpButton';
export const ELEMENT_START_FREE_TRIAL_BUTTON = 'startFreeTrialButton';
export const ELEMENT_SIGN_UP_FREE_BUTTON = 'signUpFreeButton';
export const ELEMENT_WATCH_FREE_BUTTON = 'watchFreeButton';
export const ELEMENT_CREATE_ACCOUNT_BUTTON = 'createAccountButton';

export const ELEMENT_ACTIVATE_BUTTON = 'activateButton';

export const ELEMENT_SIGN_IN_LINK = 'signInLink';
export const ELEMENT_SIGN_OUT_BUTTON = 'signOutButton';

export const ELEMENT_ADD_PAYMENT_INFO_BUTTON = 'addPaymentInfoButton';

export const ELEMENT_SHOW_REDEMPTION_CODE_BUTTON = 'showRedemptionCodeButton';
export const ELEMENT_HIDE_REDEMPTION_CODE_BUTTON = 'hideRedemptionCodeButton';

export const ELEMENT_TILE = 'tile';

export const ELEMENT_GET_STARTED_BUTTON = 'getStartedButton';
export const ELEMENT_SELECT_BUTTON = 'selectPackageButton';
export const ELEMENT_ADD_ON_PROMO_BUTTON = 'addOnPromoButton';

export const ELEMENT_OPEN_FAQ_ITEM = 'openFaqItem';
export const ELEMENT_CLOSE_FAQ_ITEM = 'closeFaqItem';

export const ELEMENT_OPEN_DEVICE_ITEM = 'openDeviceItem';
export const ELEMENT_CLOSE_DEVICE_ITEM = 'closeDeviceItem';

export const ELEMENT_OPEN_EPISODE_ITEM = 'openEpisodeItem';
export const ELEMENT_CLOSE_EPISODE_ITEM = 'closeEpisodeItem';

export const ELEMENT_DEVICE_TILE = 'DeviceTile';

export const ELEMENT_SELECT_PLAN_BUTTON = 'selectPlanButton';
export const ELEMENT_ADD_ON_BUTTON = 'addOnButton';
export const ELEMENT_REMOVE_ADD_ON_BUTTON = 'removeAddOnButton';

export const ELEMENT_NEXT_BUTTON = 'nextButton';
export const ELEMENT_PREVIOUS_BUTTON = 'previousButton';

export const ELEMENT_NAV_BUTTON = 'navButton';

export const ELEMENT_LOGGED_IN_WATCH_PHILO_LINK = 'loggedInWatchPhiloLink';

export const ELEMENT_TROUBLE_SIGNING_IN_BUTTON = 'troubleSigningInButton';

export const ELEMENT_RESEND_CODE_BY_VOICE_BUTTON = 'resendCodeByVoiceButton';
export const ELEMENT_RESEND_CODE_BY_EMAILTEXT_BUTTON = 'resendCodeByEmailTextButton';

export const ELEMENT_BACK_BUTTON = 'backButton';
export const ELEMENT_SHOW_CODE = 'showCode';

export const ELEMENT_BANNER_CTA_BUTTON = 'bannerCtaButton';

export const ELEMENT_FAST_BANNER_CTA_BUTTON = 'fastBannerCtaButton';
